import React from 'react';
import { connect } from 'react-redux';
import { intersection, map, uniq } from 'lodash';
import { StoreState } from 'state/types';
import { currentUserSiteIdsSelector, hasPermissionSelector } from 'state/Auth';
import { SubmitPayload, SubmitPayloadWithPayRate } from './types';
import {
  RoleModalViewProps,
  ConfirmationModal,
  RoleModalWithPayRates,
} from './components';
import { FeatureFlag } from 'element';
import { RoleModal } from './RoleModal';

type OwnProps = RoleModalViewProps;

type StateProps = {
  currentUserSiteIds: string[];
  canViewAllSites: boolean;
};

type DispatchProps = {};

export type Props = OwnProps & StateProps & DispatchProps;

type State = {
  payload: SubmitPayload | SubmitPayloadWithPayRate | null;
};

const getState = (props: Props): State => ({
  payload: null,
});

export class RoleModalWithPayRatesWrapperComponent extends React.Component<
  Props,
  State
> {
  readonly state = getState(this.props);

  render() {
    const { onFormSubmit, ...restProps } = this.props;

    return (
      <FeatureFlag name="multiplePayRates">
        <FeatureFlag.On>
          <>
            <RoleModalWithPayRates
              {...restProps}
              onFormSubmit={this.onFormSubmit}
            />
            <ConfirmationModal
              isOpened={this.isConfirmationModalOpened}
              onConfirmBtnClick={this.onSubmitConfirmationModal}
              onCloseBtnClick={this.closeConfirmationModal}
            />
          </>
        </FeatureFlag.On>
        <FeatureFlag.Off>
          {this.renderOriginalModal()}
        </FeatureFlag.Off>
      </FeatureFlag>
    );
  }

  private renderOriginalModal = () => {
    const { onFormSubmit, ...restProps } = this.props;
    return <RoleModal {...restProps} onFormSubmit={this.onFormSubmit} />;
  };

  private get isConfirmationModalOpened() {
    return !!this.state.payload;
  }

  private onFormSubmit = (
    payload: SubmitPayload | SubmitPayloadWithPayRate
  ) => {
    if (this.userDeletedAllAccessibleRoles(payload)) {
      this.setState({
        payload: payload as SubmitPayload,
      });
    } else {
      this.props.onFormSubmit(payload as SubmitPayload);
    }
  };

  private closeConfirmationModal = () => {
    this.setState({
      payload: null,
    });
  };

  private onSubmitConfirmationModal = () => {
    this.props.onFormSubmit(this.state.payload! as SubmitPayload);

    this.setState({
      payload: null,
    });
  };

  private userDeletedAllAccessibleRoles = ({
    user_roles,
  }: SubmitPayload | SubmitPayloadWithPayRate): boolean => {
    const { currentUserSiteIds, canViewAllSites } = this.props;

    if (canViewAllSites) {
      return false;
    }

    const selectedRolesSiteIds = uniq(
      map(user_roles, ({ site_id }) => site_id)
    );

    return !intersection(currentUserSiteIds, selectedRolesSiteIds).length;
  };
}

const mapStateToProps = (state: StoreState): StateProps => ({
  currentUserSiteIds: currentUserSiteIdsSelector(state),
  canViewAllSites: hasPermissionSelector(state, 'account.viewallsites'),
});

export const RoleModalWithPayRatesWrapper = connect(mapStateToProps)(
  RoleModalWithPayRatesWrapperComponent
);

